// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  dev: false,
  keycloakUrl: "https://keycloak.tcema.tc.br",
  keycloakRealm: "TCE",
  keycloakClientId: "captureweb",
  keycloakClientSecret: "SRwhMAnbJV0mnTuHhnegp2o5AfOfmFj4",
  apiUrl: "https://backend.capture.tcema.tc.br/capture",
  
};

// export const environment = {
//   production: false,
//   keycloakUrl: 'http://192.168.15.228:8080',
//   keycloakRealm: 'tce-pi',
//   keycloakClientId: 'captureweb',
//   keycloakClientSecret: '0edfdde5-54c8-4daf-b396-b7faefacaf3c',
//   apiUrl: 'http://192.168.15.230:1007/capture'
//   //apiUrl: 'http://192.168.15.235:8080/capture'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
